import { useMemo, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { Pagination } from './../components/Pagination';
import useQueryString from './../../utils/hooks/useQueryString';
import { Loading } from './../components/Loading';
import { TopicLatest } from "./TopicLatest";
import { TopicListItem } from "./TopicListItem";
import Api, { createFetchErrorMessage } from "utils/api/Api";
import { ErrorMessageBox } from "bf-library";
const queryString = require('query-string');

export const TopicList = () => {
  const navigate = useNavigate();
  const { page } = useQueryString();
  const { school } = useParams();

  const { data:topicList, isFetching, isError, error } = useQuery({
    queryKey:['donghwa/list', page],
    queryFn:()=>Api.get(`/api/dongwha/topic/list?page=${page||0}`),
    placeholderData:keepPreviousData,
  })


  const fetchList = useCallback((page = 0) => {
    let tempSearchOption = { page:page };
    navigate(`/${school}/donghwa?${queryString.stringify(tempSearchOption)}`);
  }, [navigate, school]);
  

    const topicListElement = useMemo(() => {
        if(isError) return <ErrorMessageBox message={createFetchErrorMessage(error).message} />
        if(topicList?.data?.list.length<=0) return <div className="no_data"><p>지난 이야기가 없습니다.</p></div>;
        return topicList?.data?.list.map((topic) => <TopicListItem topic={topic} key={topic.id} />);
    }, [topicList, isError, error]);
  
    
  return(
    <div className="mainPage">
      <TopicLatest />
      <div className="topic_list contents">
        <div className="inner">
          <div className="hdline">
            <p className="desc">친구들의 <span>이야기</span>를 만나보아요.</p>
          </div>
          <ul className={`list ${topicList?.data?.list <= 0 && "no_list"}`}>
            {topicListElement}
            <Loading overlay={true} active={isFetching} />
          </ul>
          <Pagination page={topicList?.data?.page || 0} totalPage={topicList?.data?.totalPages || 1} gotoPage={fetchList}/>
        </div>
      </div>
    </div>
  );
};